<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    @if (vm.fakturaer.length === 0) {
      <empty-page-badge svgIcon="fakturagodkendelse" [overskrift]="'Ingen fakturaer til godkendelse'">
        <p>Du har i &oslash;jeblikket ingen fakturaer til godkendelse.</p>
      </empty-page-badge>
    }
    @if (vm.fakturaer.length !== 0) {
      <fakturagodkendelse-liste
        [fakturaer]="vm.fakturaer"
        (dokumentUrlerNeeded)="hentDokumentUrler($event)"
        [onAfvis]="afvis"
        [onGodkend]="godkend"
        >
      </fakturagodkendelse-liste>
    }
  }
</dff-side>
